import classNames from 'classnames';
import { ReactNode } from 'react';

type QuoteInfoListItemProps = {
  label: string;
  value: ReactNode;
  className?: string;
  labelClassName?: string;
};

export function QuoteInfoListItem({ label, value, className, labelClassName }: QuoteInfoListItemProps) {
  return (
    <li
      className={classNames(
        'flex-x list-group-item justify-content-between p-0 quote-list-item border-bottom border-opacity-40',
        className,
      )}
    >
      <label className={classNames('text-secondary', labelClassName)}>{label}</label>
      <div className={'text-truncate flex-x gap-2 fw-medium'}>{value}</div>
    </li>
  );
}
